'use client';

import { useParams } from 'next/navigation';
import { PropsWithChildren, Suspense } from 'react';
import { ThemeProvider } from 'styled-components';
import { SWRConfig } from 'swr/_internal';

import { Dialogs } from '@/components/dialogs';
import { NavigationEvents } from '@/components/internal/NavigationEvents';
import { Preloader } from '@/components/Preloader/Preloader';
import TranslationsProvider from '@/components/TranslationsProvider';
import { useGAConfigHook } from '@/modules/googleAnalytics';
import { DEFAULT_LOCALE } from '@/modules/localization';
import theme from '@/theme';

import { GlobalStyles } from '@/styles/GlobalStyles';

export default function Template({ children }: PropsWithChildren) {
  useGAConfigHook();

  const params = useParams();

  const locale =
    typeof params.locale === 'string' ? params.locale : DEFAULT_LOCALE;

  return (
    <SWRConfig>
      <ThemeProvider theme={theme}>
        <GlobalStyles theme={theme} />
        <Suspense fallback={<Preloader />}>
          <TranslationsProvider locale={locale}>
            <NavigationEvents />
            {children}
            <Dialogs />
          </TranslationsProvider>
        </Suspense>
      </ThemeProvider>
    </SWRConfig>
  );
}
